module.exports = __webpack_public_path__ + "img/Pen.ba28f56f.svg";